import {
  GET_POLICIES_REQUEST,
  GET_POLICIES_SUCCESS,
  GET_POLICIES_FAILURE,
} from "../actions/types";

const initialState = {
  loading: false,
  error: null,
  policies: [],
};

const policyReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_POLICIES_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case GET_POLICIES_SUCCESS:
      return {
        ...state,
        loading: false,
        policies: action.payload,
      };

    case GET_POLICIES_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default policyReducer;
